/**
 * Резолвер URL для картинок:
 * - absolute URL (http/https/data/blob) возвращает как есть;
 * - локальные пути из старого формата assets/puzzles/* переводит в URL бакета;
 * - пути daily/* и packs/* тоже переводит в URL бакета;
 * - прочие относительные пути остаются локальными (/path).
 */

function getBucketBaseUrl(): string {
  const raw = import.meta.env.VITE_PUZZLE_BUCKET_BASE_URL ?? 'https://storage.yandexcloud.net/puzzle-game';
  return String(raw).replace(/\/+$/, '');
}

function isAbsoluteUrl(url: string): boolean {
  return /^(?:https?:)?\/\//.test(url) || url.startsWith('data:') || url.startsWith('blob:');
}

function joinUrl(base: string, suffix: string): string {
  return `${base}/${suffix.replace(/^\/+/, '')}`;
}

export function resolvePublicAssetPath(path: string): string {
  const trimmed = path.trim();
  if (!trimmed) return '';
  if (isAbsoluteUrl(trimmed)) return trimmed;

  const bucketBase = getBucketBaseUrl();
  const normalized = trimmed.replace(/^\/+/, '');

  if (normalized.startsWith('assets/puzzles/')) {
    const suffix = normalized.slice('assets/puzzles/'.length);
    return joinUrl(bucketBase, suffix);
  }
  if (normalized.startsWith('daily/') || normalized.startsWith('packs/')) {
    return joinUrl(bucketBase, normalized);
  }

  return normalized.startsWith('/') ? normalized : '/' + normalized;
}
